import { ICustomerOption, IUserCustomerPreview } from '~/common/types';

export function customerToOption(
  customer: Omit<IUserCustomerPreview, 'internalStocks'>,
): ICustomerOption {
  return {
    label: `${customer.name} (${customer.code})`,
    value: customer.id,
    city: customer.deliveryInformation.city,
    zipCode: customer.deliveryInformation.zipCode,
    name: customer.name,
  };
}
